// Importe con IVA para seQura: total de la calculadora o precio unitario publicado.
(() => {
  if (window.MPSequraAmount) return;
  window.MPSequraAmount = true;

  // La validación coincide con la calculadora, incluidos los separadores de miles.
  const parse = value => {
    let normalized = String(value || '').trim();
    const dotCount = (normalized.match(/\./g) || []).length;
    if (normalized.includes(',')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (dotCount > 1 || /^[-+]?\d+\.\d{3}$/.test(normalized)) {
      normalized = normalized.replace(/\./g, '');
    }
    return Number(normalized);
  };
  const format = cents => {
    const [integer, decimal] = (cents / 100).toFixed(2).split('.');
    return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimal} €`;
  };
  const update = () => {
    document.querySelectorAll('.product-info__block-list [data-mp-sequra-amount]').forEach(span => {
      // Precio y calculadora comparten esta lista; un quick-buy sin calculadora usa su unidad.
      const scope = span.closest('.product-info__block-list') || span.closest('product-rerender, quick-buy-modal, .shopify-section') || document;
      const calc = scope.querySelector('flooring-calculator');
      let cents = Number(span.dataset.unitCents);
      const input = parse(calc?.$input?.value);
      if (calc?._calc && Number.isFinite(input) && input > 0) {
        // Prestige renueva el precio, pero conserva la configuración de la calculadora.
        const variantNetCents = Number(span.dataset.variantNetCents);
        const vatMultiplier = Number(span.dataset.vatMultiplier);
        let gross;
        if (Number.isFinite(variantNetCents) && variantNetCents > 0 && Number.isFinite(vatMultiplier) && vatMultiplier > 0) {
          gross = Math.round(calc._calc.qty * variantNetCents * vatMultiplier);
        } else if (calc.cfg?.priceCents > 0) {
          const total = calc._calc.qty * calc.cfg.priceCents;
          gross = calc.cfg.taxesIncluded ? total : Math.round(total * (1 + calc.cfg.taxPct / 100));
        }
        if (Number.isFinite(gross) && gross > 0) cents = gross;
      }
      const text = format(cents);
      if (span.textContent !== text) span.textContent = text;
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  for (const type of ['input', 'change', 'mp:calc', 'cart:change', 'variant:change', 'product:rerender']) {
    // product:rerender no propaga; el siguiente frame lee los bloques ya reemplazados por Prestige.
    document.addEventListener(type, schedule, true);
  }
  // En ml, abrir o quitar merma recalcula sin emitir mp:calc.
  document.addEventListener('click', event => {
    if (event.target.closest('flooring-calculator [data-role="waste-open"], flooring-calculator [data-role="waste-close"]')) schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
